<template>
    <div :class="['page campaign',{ off: !pageOn }]">
        <VHeader type="back" @back="back" />
        <div class="page-content rating">
            <h1 style="text-align: center;margin-top: 30px;font-weight: 400;">My Account</h1>
            <div class="account-detail">
                <h3>Client<span>{{ account.clientTitle }}</span></h3>
                <h3>Username<span>{{ account.un }}</span></h3>
                <p class="btn" @click="logout">logout</p>
            </div>
            
        </div>
    </div>
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { mapMutations } from 'vuex'
import { pageOn } from '@/utils/pageOn.js'
import Alert from '@/utils/Alert.js'
import WebSoc from '@/utils/WebSoc.js'

export default {
    name: 'my-account',
    components: {
        VHeader,
    },
    mixins: [ pageOn ],
    computed: {
        auth () { return this.$store.state.auth },
        pages () { return this.$store.state.pages },
    },
    data () {
        return {
            account: false,
        }
    },
    mounted () {
        WebSoc.SEND({ t: 'getAccount', data: { auth: this.auth }},resp => {
            this.account = resp;
            console.log('getAccount resp',resp);
        });
    },
    methods: {
        logout () {
            Alert.yesno('Logout from this device ?',yes => {
                if ( !yes ) return;
                WebSoc.SEND({ t: 'loyaltyClientLogout', data: { auth: this.auth }},resp => {
                    console.log('resp',resp);
                    try {
                        ['loyalty_id','loyaltyId'].forEach(key => localStorage.removeItem(key));
                    } catch(e) {};
                    this.setAuth(false);
                    this.setPages(['account','auth']);
                    console.log('setPages');
                    Alert.message('Logout Successful',2000);
                })
            })
        },
        back () {
            this.pageOn = false;
            setTimeout(() => {
               this.popPage('client-campaign');
            },200);
        },
        ...mapMutations(['pushPage','popPage','setAuth','setPages'])
    }
}

</script>

<style lang="scss">
.account-detail {
    .btn { float: left; width: calc(100% - 30px); }
    h3 {
        width: 90%;
        margin: 5% 0px 10px 5%;
        font-weight: 400;
        float: left;
        text-align: center;
        span { float: right; width: 100%; margin-top: 10px; }
    }
}
</style>